import {
  GET_ADMIN_USER_NOTIFICATIONS,
  GET_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  GET_ADMIN_USER_NOTIFICATIONS_ERROR,
  CREATE_USER_NOTIFICATIONS,
  CREATE_USER_NOTIFICATIONS_SUCCESS,
  CREATE_USER_NOTIFICATIONS_ERROR,
  UPDATE_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_USER_NOTIFICATIONS_ERROR,
  DELETE_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS_SUCCESS,
  DELETE_USER_NOTIFICATIONS_ERROR,
  EXPORT_ADMIN_USER_NOTIFICATIONS,
  EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR,
  BULK_EDIT_USER_NOTIFICATIONS,
  BULK_EDIT_USER_NOTIFICATIONS_SUCCESS,
  BULK_EDIT_USER_NOTIFICATIONS_ERROR,
  GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS,
  GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS_SUCCESS,
  GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS_ERROR,
  PREVIEW_USER_NOTIFICATIONS_BULK_EDIT,
  PREVIEW_USER_NOTIFICATIONS_BULK_EDIT_SUCCESS,
  PREVIEW_USER_NOTIFICATIONS_BULK_EDIT_ERROR,
  RESET_USER_NOTIFICATIONS_BULK_EDIT_PREVIEW,
  RESET_ADMIN_USER_NOTIFICATIONS_PAGE_CACHE,
} from "./actionTypes"

export const getAdminUserNotifications = (query_params, paginated) => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS,
    payload: query_params,
    paginated: paginated
  }
}

export const getAdminUserNotificationsSucess = (user_notifications, meta = {}) => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
    meta,
  }
}

export const getAdminUserNotificationsError = error => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const createUserNotifications = (user_notifications) => {
  return {
    type: CREATE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const createUserNotificationsSucess = user_notifications => {
  return {
    type: CREATE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const createUserNotificationsError = error => {
  return {
    type: CREATE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const updateUserNotifications = (user_notifications) => {
  return {
    type: UPDATE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const updateUserNotificationsSucess = user_notifications => {
  return {
    type: UPDATE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const updateUserNotificationsError = error => {
  return {
    type: UPDATE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const deleteUserNotifications = (user_notifications) => {
  return {
    type: DELETE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const deleteUserNotificationsSucess = user_notifications => {
  return {
    type: DELETE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const deleteUserNotificationsError = error => {
  return {
    type: DELETE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const exportAdminUserNotifications = (query_params) => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS,
    payload: query_params
  }
}

export const exportAdminUserNotificationsSuccess = () => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  }
}

export const exportAdminUserNotificationsError = error => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

// payload: { changes: { action, status, reason }, ids: [...] }
// or { changes, select_all: true } -- see buildBulkEditPayload in saga.js
export const bulkEditUserNotifications = (payload) => ({
  type: BULK_EDIT_USER_NOTIFICATIONS,
  payload,
})

// payload: the created BulkEditRequest
export const bulkEditUserNotificationsSuccess = (bulkEditJob) => ({
  type: BULK_EDIT_USER_NOTIFICATIONS_SUCCESS,
  payload: bulkEditJob,
})

export const bulkEditUserNotificationsError = (error) => ({
  type: BULK_EDIT_USER_NOTIFICATIONS_ERROR,
  payload: error,
})

export const getUserNotificationsBulkEditStatus = () => ({
  type: GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS,
})

export const getUserNotificationsBulkEditStatusSuccess = (bulkEditJob) => ({
  type: GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS_SUCCESS,
  payload: bulkEditJob,
})

export const getUserNotificationsBulkEditStatusError = (error) => ({
  type: GET_USER_NOTIFICATIONS_BULK_EDIT_STATUS_ERROR,
  payload: error,
})

// payload: same shape as bulkEditUserNotifications' (the reason isn't
// needed to preview how many notifications would be affected)
export const previewUserNotificationsBulkEdit = (payload) => ({
  type: PREVIEW_USER_NOTIFICATIONS_BULK_EDIT,
  payload,
})

// payload: { count, target_key, lock_held, changes } from POST /admin_bulk_edits/preview
export const previewUserNotificationsBulkEditSuccess = (payload) => ({
  type: PREVIEW_USER_NOTIFICATIONS_BULK_EDIT_SUCCESS,
  payload,
})

export const previewUserNotificationsBulkEditError = (error) => ({
  type: PREVIEW_USER_NOTIFICATIONS_BULK_EDIT_ERROR,
  payload: error,
})

export const resetUserNotificationsBulkEditPreview = () => ({
  type: RESET_USER_NOTIFICATIONS_BULK_EDIT_PREVIEW,
})

// Drops cached pages so the next fetch shows the data after a bulk edit.
export const resetAdminUserNotificationsPageCache = () => ({
  type: RESET_ADMIN_USER_NOTIFICATIONS_PAGE_CACHE,
})
